<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4>
        <v-card class="elevation-12">
          <v-toolbar dark color="primary">
            <v-toolbar-title>Registro</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-title v-if="datos">{{ datos.name }}</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-form>
              <v-text-field
                prepend-icon="person"
                name="user"
                label="Usuario"
                type="text"
                v-model="displayName"
              ></v-text-field>
              <v-text-field
                v-if="phoneEmail"
                prepend-icon="phone"
                name="loginPhone"
                label="Sin Email"
                type="text"
                disabled
                :value="phoneEmail"
              ></v-text-field>
              <v-text-field
                v-else
                prepend-icon="mail"
                name="login"
                label="Email"
                type="text"
                v-model="email"
              ></v-text-field>
              <v-text-field
                id="password"
                prepend-icon="lock"
                name="password"
                label="Password"
                type="password"
                v-model="password"
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-checkbox v-model="registerData.sinEmail" label="No tengo email">
            </v-checkbox>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="register">Registrarse</v-btn>
          </v-card-actions>
        </v-card>
        <v-alert v-model="alert" dismissible type="error">
          {{ errorMessage }}
        </v-alert>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: "Registro-Usuario",
  data: () => ({
    email: "",
    registerData: {},
    password: "",
    displayName: "",
    alert: false,
    errorMessage: "",
    sinEmail: false
  }),
  props: ["datos"],
  created() {
    // this.$store.dispatch('setRespuestaSistema')
    // this.setRegisterData()
  },
  mounted() {
    // this.$store.dispatch('setRespuestaSistema')
  },
  watch: {
    /* registroId(newId) {
                if (newId) {
                    this.$store.dispatch('setRespuestaSistema', newId);    
                }
            }, */
    data(newData) {
      if (newData) {
        this.registerData = newData;
        // this.$store.dispatch('setRespuestaSistema')
      }
    }
  },
  computed: {
    data() {
      return this.datos;
    },
    registroId() {
      return this.$store.getters.getNewUserRegisterId;
    },
    phoneEmail() {
      let result = false;
      if (this.datos && this.registerData.sinEmail) {
        if (this.datos.tlf) {
          result = this.datos.tlf; // `${this.datos.tlf}@sinemail.es`
        }
      }
      return result;
    },
    respuestaSistema() {
      return this.$store.getters.getRespuestaSistema;
    }
  },
  methods: {
    enviarDatos() {
      this.$store.dispatch("newRegisterUser", this.registerData);
    },
    setRegisterData() {
      this.registerData = this.datos;
    },
    register() {
      let email = {
        email: "",
        valid: false
      };
      if (!this.registerData.sinEmail) {
        email = this.validateEmail(this.email);
        if (!email.valid) {
          this.errorMessage =
            "Debe indicar un email válido. Mínimo 6 caracteres.";
          this.alert = true;
          return false;
        }
      }
      const password = this.validarPassword(this.password);
      if (!password.valid) {
        this.errorMessage =
          "Debe indicar un password válido. Mínimo 8 caracteres y debe contener al menos una letra en Mayúscula, una en minúscula y un dígito. Puede usar, además, cualquiera de estos caracteres especiales: !@#$%^&*";
        this.alert = true;
        return false;
      }
      const displayName = this.validateDisplayName(this.displayName);
      if (!displayName.valid) {
        this.errorMessage =
          "Debe indicar un Nombre de usuario válido. Mínimo 4 caracteres y puede tanto letras como números. No se admiten espacios ni otros caracteres";
        this.alert = true;
        return false;
      }
      this.registerData.email = email.email;
      this.registerData.password = password.password;
      this.registerData.displayName = displayName.valor;
      this.registerData.verificarEmail = email.valid ? true : false;
      this.$store.dispatch("newRegisterUser", this.registerData);
    },
    validateEmail(str) {
      const REGEX_EMAIL = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      let valid = false;
      if (str) {
        if (typeof str === "string") {
          if (str.length > 4) {
            str = str.toLowerCase().replace(/\s/g, "");
            valid = REGEX_EMAIL.test(str);
          }
        }
      }
      return {
        email: str,
        valid: valid
      };
    },
    validarPassword(str) {
      /**
       * Passwords must be
       * - At least 8 characters long, max length anything
       * - Include at least 1 lowercase letter
       * - 1 capital letter
       * - 1 number
       * - 1 special character => !@#$%^&*
       */
      // const REGEX_PASSWORD = /^(?=.*[\d])(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&*])[\w!@#$%^&*]{8,}$/;
      const REGEX_PASSWORD = /^(?=.*[\d])(?=.*[A-Z])(?=.*[a-z])[\w!@#$%^&*]{8,}$/;
      let valid = false;
      if (str) {
        if (typeof str === "string") {
          valid = REGEX_PASSWORD.test(str);
        }
      }
      return {
        password: str,
        valid: valid
      };
    },
    validateDisplayName(str) {
      const REGEX_NAME = /^[0-9a-zA-Z]{4,}$/; // Caracteres especiales opcionales
      let valid = false;
      if (str) {
        if (typeof str === "string") {
          valid = REGEX_NAME.test(str);
        }
      }
      return {
        valor: str,
        valid: valid
      };
    }
  }
};
</script>
